var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import analytics from '../analytics';
import fetchWithTimeout from '../utils/fetchWithTimeout';
export const generateHotelSummary = options => __awaiter(void 0, void 0, void 0, function* () {
  const {
    fetchRequestOptions,
    setSummaryText,
    setSummaryIsLoading,
    hotelDetail,
    otherOptions,
    setHasSummaryError,
    prompts
  } = options;
  setSummaryIsLoading(true);
  try {
    const res = yield fetchWithTimeout(`/genai-svc/genai/chat/hotelSummary`, {
      method: 'POST',
      body: JSON.stringify({
        prompts,
        hotelDetail,
        productId: 5,
        otherOptions
      }),
      headers: Object.assign({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Content-Encoding': 'identity'
      }, fetchRequestOptions === null || fetchRequestOptions === void 0 ? void 0 : fetchRequestOptions.headers)
    }, 10000);
    const fullSummaryWords = [];
    if (res.status !== 200) {
      throw new Error(res.statusText);
    }
    if (res.body && res.body.getReader && typeof res.body.getReader === 'function') {
      const reader = res.body.getReader();
      reader.read().then(function processStream({
        done,
        value: u8ArrValue
      }) {
        return __awaiter(this, void 0, void 0, function* () {
          if (done) {
            setSummaryIsLoading(false);
            setHasSummaryError(false);
            return;
          }
          if (u8ArrValue) {
            const value = u8ArrValue.filter(x => x !== 0);
            const response = new Response(value);
            const textRes = yield response.text();
            fullSummaryWords.push(textRes);
            if (fullSummaryWords === null || fullSummaryWords === void 0 ? void 0 : fullSummaryWords.join('')) {
              setSummaryText(fullSummaryWords.join(''));
            }
          }
          return reader.read().then(processStream);
        });
      }).catch(err => {
        analytics.logError({
          message: 'Error generating hotel summary',
          error: JSON.stringify(err),
          loggedFrom: 'generateHotelSummary'
        });
        setHasSummaryError(true);
        setSummaryIsLoading(false);
      });
    }
  } catch (err) {
    analytics.logError({
      message: 'fetch request failed',
      error: JSON.stringify(err),
      loggedFrom: 'generateHotelSummary'
    });
    setHasSummaryError(true);
    setSummaryIsLoading(false);
  }
});